import React from "react";
import { subBanner } from "../../../data/HomeData";
const SubBanner = () => {
  return (
    <div className="bg-[#F9FAFB] space-y-5 py-16 px-10">
      <p className="text-center text-[17px]">
        Verify credentials of 300+ applications
      </p>
      <div className="flex flex-wrap gap-3 justify-around items-center">
        {subBanner.map((item, index) => (
          <div key={index} className="flex gap-2 items-center">
            <img src={item.icon} alt="" />
            <h3 className="text-3xl font-bold text-black">{item.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubBanner;
